module.exports = __webpack_public_path__ + "img/card_icon_v1_jcb.6b7288b9.svg";